










import Vue from "vue";
import Component from "vue-class-component";
@Component
export default class realVoicePayPage extends Vue {
	info: any = {};
	created() {
		let { anchorAvatar, anchorName, wordNum, orderPrice } = this.$route.query;
		this.info = { anchorAvatar, anchorName, wordNum, orderPrice };
	}
}
